/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * warning_word_api での校正対象
 * @export
 * @interface WarnedWord
 */
export interface WarnedWord {
    /**
     * 対象文字列
     * @type {string}
     * @memberof WarnedWord
     */
    word: string;
    /**
     * 対象文字列の長さ
     * @type {number}
     * @memberof WarnedWord
     */
    length: number;
    /**
     * 対象文字列の、元の文章内での開始位置; offset
     * @type {number}
     * @memberof WarnedWord
     */
    start: number;
}

export function WarnedWordFromJSON(json: any): WarnedWord {
    return WarnedWordFromJSONTyped(json, false);
}

export function WarnedWordFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarnedWord {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'word': json['word'],
        'length': json['length'],
        'start': json['start'],
    };
}

export function WarnedWordToJSON(value?: WarnedWord | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'word': value.word,
        'length': value.length,
        'start': value.start,
    };
}

